import { lazy } from 'react';

export const ForbiddenPage = lazy(
  () => import('./ui/ForbiddenPage/ForbiddenPage'),
);
